// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"594":"about","597":"projects","636":"landing"}[chunkId] + "." + {"594":"d4339ad1","597":"22418b77","636":"d055aafa"}[chunkId] + ".css";
};